import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'about_UPDATE',
    smsDelete : 'about_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        about: {},
        involvement: [],
        banner: {},

        submitSuccess: false,
        aboutLoading: false,
        aboutError: false,
        bannerLoading: false,
        bannerError: false,
        involvementLoading: false,
        involvementError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_ABOUT(state, about) {
            state.about = about;
        },

        SET_BANNER(state, banner) {
            state.banner = banner;
        },

        SET_INVOLVEMENT(state, involvement) {
            state.involvement = involvement;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        ABOUT_LOADING (state, loading) {
            state.aboutLoading = loading;
        },

        ABOUT_ERROR (state, hasError) {
            state.aboutError = hasError;
        },

        BANNER_LOADING (state, loading) {
            state.bannerLoading = loading;
        },

        BANNER_ERROR (state, hasError) {
            state.bannerError = hasError;
        },

        INVOLVEMENT_LOADING (state, loading) {
            state.involvementLoading = loading;
        },

        INVOLVEMENT_ERROR (state, hasError) {
            state.involvementError = hasError;
        }
    },

    actions: {
        // Home Banner
        async addBanner ({commit, dispatch}, payload) {
            commit('BANNER_LOADING', true);
            commit('BANNER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_banner, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchBanner')
                return response

            } catch (e) {
                commit('BANNER_ERROR', true);
            } finally {
                commit('BANNER_LOADING', false);
            }
        },

        async fetchBanner ({ commit }) {
            commit('BANNER_LOADING', true);
            commit('BANNER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_banner, config);
                let response = result.data.data
                commit('SET_BANNER', response);
                return result
            } catch(error) {
                commit('BANNER_ERROR', true);
            } finally {
                commit('BANNER_LOADING', false);
            }
        },

        // About
        async addAbout ({commit, dispatch}, payload) {
            commit('ABOUT_LOADING', true);
            commit('ABOUT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_about, payload.about, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAbout')
                return response

            } catch (e) {
                commit('ABOUT_ERROR', true);
            } finally {
                commit('ABOUT_LOADING', false);
            }
        },

        async fetchAbout ({ commit }) {
            commit('ABOUT_LOADING', true);
            commit('ABOUT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_about, config);
                let response = result.data.data
                commit('SET_ABOUT', response);
                return result
            } catch(error) {
                commit('ABOUT_ERROR', true);
            } finally {
                commit('ABOUT_LOADING', false);
            }
        },

        // Involvement
        async addInvolvement ({commit, dispatch}, payload) {
            commit('INVOLVEMENT_LOADING', true);
            commit('INVOLVEMENT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_involvement, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchInvolvement')
                return response

            } catch (e) {
                commit('INVOLVEMENT_ERROR', true);
            } finally {
                commit('INVOLVEMENT_LOADING', false);
            }
        },

        async fetchInvolvement ({ commit }) {
            commit('INVOLVEMENT_LOADING', true);
            commit('INVOLVEMENT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_involvement, config);
                let response = result.data.data
                commit('SET_INVOLVEMENT', response);
                return result
            } catch(error) {
                commit('INVOLVEMENT_ERROR', true);
            } finally {
                commit('INVOLVEMENT_LOADING', false);
            }
        }
    },

    getters: {}
}
